import { Model } from "survey-core";

// Survey config stores section headers in ALL CAPS ("REPORTING PARTY
// INFORMATION") but the condensed report renders top-level section titles in
// title case ("Reporting Party Information").
const toTitleCase = (s: string): string =>
  s.replace(
    /\w\S*/g,
    (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(),
  );

/**
 * Normalize panel / section titles for the condensed report:
 *
 * - Title-case authored section headers (regular Panels and PanelDynamic outer
 *   headers like "INVOLVED ITEM(S)").
 * - Suppress SurveyJS's name fallback: once a panel is made collapsible (the
 *   condensed report sets every section's `state` to "expanded"), SurveyJS
 *   renders the element's internal `name` as the clickable header when no title
 *   is authored. This happens for both regular Panels and PanelDynamics, so any
 *   untitled section gets a blank header instead — we never want an internal
 *   name leaking into the report.
 *
 * SurveyJS treats an empty string as "use the name", so a single space is used
 * to force a visibly-empty header that still keeps the section bar and collapse
 * chevron (rather than removing the header entirely).
 */
export const applyCondensedReportTitles = (survey: Model): void => {
  // PanelDynamic is a Question, so panels and paneldynamics live in different
  // collections; normalize both the same way.
  const normalizeTitle = (el: any): void => {
    if (el.locTitle && !el.locTitle.isEmpty) {
      el.title = toTitleCase(el.title);
    } else {
      el.title = " ";
    }
  };

  survey.getAllPanels().forEach(normalizeTitle);
  survey.getAllQuestions().forEach((q: any) => {
    if (q.getType?.() === "paneldynamic") normalizeTitle(q);
  });
};
